import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../core/services/utility.service';
import { FeedbackService } from '../../core/services/feedback.service';
import { Constants } from '../../core/config/Constants';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css'],
  providers:[FeedbackService]
})
export class FeedbackComponent implements OnInit {

  eventId:string='';
  prop:boolean=false;
  
  rating_sum:number=0;
  avg_rating:number;
  total_feedback:number;

  feedbackList: Array<any> = new Array();
  NO_FEEDBACK_DESCRIPTION = Constants.NO_FEEDBACK_DESCRIPTION;
 
  constructor(private feedbackService: FeedbackService,private extraService:ExtraService,private route: ActivatedRoute,private router:Router,
    private utilityService:UtilityService) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => { 
      let id = params['eventId']; 
      this.eventId = id;
      this.extraService.setCurrentEventId(id);
      if(id) {
        this.setFeedbackData(id);
      }
    });
    
  }

  setFeedbackData(id){
    this.feedbackService.getFeedbackData(id).subscribe(event=>{
      this.feedbackList = new Array();
      this.rating_sum = 0;
      if(event) {
        for(let key in event){
          this.rating_sum += event[key].rating
          this.feedbackList.push({feedback:event[key].feedback,name:event[key].postedByName,rating:event[key].rating});
        }
        
        this.total_feedback = this.feedbackList.length;
        this.avg_rating = this.rating_sum/this.total_feedback;
        this.avg_rating = Math.floor(this.avg_rating *10);
        this.avg_rating = this.avg_rating /10;

      } else {
        this.prop = true;
      }
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/event/feedback/feedback.component.ts